import React from 'react'
import HeroSectionGot from './HeroSectionGot';
import CharactersGot from './CharactersGot';
import FooterGot from './FooterGot';
import BooksGot from './BooksGot';
import SeriesGot from './SeriesGot';

function HomeGot() {
  return (
    <>
      <HeroSectionGot />
      <CharactersGot />
      <BooksGot />
      <SeriesGot />
      <FooterGot />
    </>
  );
}

export default HomeGot